document.addEventListener("DOMContentLoaded", () => {
  const inputSearch = document.querySelector('#cmdk-input');
  const searchModal = document.querySelector('predictive-search-component');

  if (!inputSearch || !searchModal) return;

  // 1. Trigger scroll when text
  let debounceTimer;
  inputSearch.addEventListener("input", () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      window.dispatchEvent(new Event("scroll"));
    }, 300);
  });

  // 2. Trigger scroll while modal open
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (
        mutation.attributeName === "class" &&
        searchModal.classList.contains("predictive-search--expanded")
      ) {
        window.dispatchEvent(new Event("scroll"));
      }
    });
  });

  observer.observe(searchModal, { attributes: true });
});

let debounceTimer = null;
document.body.addEventListener('click', function (e) {
  const label = e.target.closest('.variant-option__button-label');
  if (!label) return;

  const input = label.querySelector('input[type="radio"]');
  if (!input) return;

  const variantId = Number(input.dataset.variantId);
  if (isNaN(variantId)) return;

  const container = label.closest('[bss-b2b-product-form-id]');
  if (!container) return;

  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(() => {
    const priceEl = container.querySelector('product-price');
    if (priceEl) {
      priceEl.setAttribute('bss-b2b-variant-id', variantId);
    }

    const productForm = document.querySelector('[bss-b2b-main-product-form]');
    if (!productForm) return;

    BSS_B2B.observer.productSubject.notifyObserver(
      'VariantChange',
      'VariantSelectChange',
      { productForm }
    );

  }, 1000);
});


// begin Lock customize
const config = { attributes: false, childList: true, subtree: true };

const callback = (mutationList, observer) => {
  const ltspMessages = document.querySelectorAll('.bss-lock-element');
  ltspMessages.forEach(message => {
    const linkElement = message.querySelector('a');
    if (linkElement) {
        linkElement.target = '_self'
    }
  });
};

const observer = new MutationObserver(callback);

observer.observe(document.body, config);

// end Lock customize